import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Box, Typography } from "@launchmetrics/lm-ui";
import { Select, SelectOption } from '@launchmetrics/lm-ui';

import { setReportClipping } from "store/article/report/reducers";
import type { FeedClippingCount } from "store/models/reportConfiguration";
import { State } from "store/types";

import { Language } from "./fields/common/Language";
import { Currency } from "./fields/common/Currency";
import { GroupLocation } from "./fields/common/GroupLocation";
import { PLACEMENTS_COUNT } from "./fields/consts";
import { useFeedWarnings } from "./hooks";
import { isEmpty } from "lodash";

export const Online: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	let feedClippings = useSelector((state: State) => state.article.report.configuration.definition.settings.feedClippings);

	useEffect(() => {
		if (!feedClippings || !feedClippings.length) {
			dispatch(setReportClipping({ feedId: "all", count: 10 }));
		}
	}, [dispatch, feedClippings]);

	const isSelected = useCallback((count: number) => {
		if (!feedClippings || !feedClippings.length) return false;
		return feedClippings[0].count === count;
	}, [feedClippings]);


	const disabled = useSelector((state: State) => state.article.report.formDisabled);

	const warning = useFeedWarnings();

	return (
		<>
			{warning && 
				<Box className='side-panel-content-entry'>
					{warning}
				</Box>
			}
			<Box className='side-panel-content-entry'>
				<Box><Typography variant='textSmBold'>{t('reports.groups')}</Typography></Box>
				<GroupLocation />
			</Box>

			<Box className='side-panel-content-entry'>
				<Box><Typography variant='textSmBold'>{t('reports.settings')}</Typography></Box>
				<Language  />
				<Currency />
			</Box>

			<Box className='side-panel-content-entry'>
				<Box><Typography variant='textSmBold'>{t('reports.content')}</Typography></Box>
				<Box className='side-panel-content-entry-element'>
					<Box>
						<Select 
							placeholder={t('reports.content_text') as string} 
							disabled={disabled}
							defaultValue={
								isEmpty(feedClippings) ? undefined :
								 { key: feedClippings[0].count.toString(), value: t('reports.feeds.first_number_placements', {  count: feedClippings[0].count }) as string }
							}
						>
							{PLACEMENTS_COUNT.map((count, index) => (
								<SelectOption
									id={`report-feed-clipping-${count}`}
									selected={isSelected(count)}
									onClick={() => dispatch(setReportClipping({ feedId: "all", count: count as FeedClippingCount }))}
									key={index}
									optionValue={{ key: count.toString(), value: t('reports.feeds.first_number_placements', { count }) as string }}
								/>
							))}
						</Select>
					</Box>
				</Box>
			</Box>
		</>
	);
};
